import React, { useState, useEffect } from "react";
import ApiService from "../services/ApiService";
import { toast } from "react-toastify";
import { Table,Container } from "react-bootstrap";
import logo from "../assets/img/mse-logo.webp";

const SummaryScreen = ({attempt_id, onReviewClick}) => {
  
  const [subsets, setSubsets] = useState(null);
  const [isLoading, setLoading] = useState(true);


  const getTestSummary = async () => {
    try {
      setLoading(true);
      const response = await ApiService.request({
          method: "GET",
          url: `getTestSummary`,
          params: {attempt_id},
        });
      const data = response.data;

      if (data && data.status === true) {
        setSubsets(data.data);
      } else {
        toast.error(data.message );
      }
    } catch (error) {
      console.error("Error fetching packages:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getTestSummary();
  }, []);


  

  return (
    <Container className="mt-3 mb-10">

      <h5 className="text-center">
        <img  src={logo} alt="MSE Logo"
          className="img-fluid" style={{ maxWidth: "250px" }}  /> <br /><br />
          UCAT Practice Test  </h5>

         <h5>Summary Score Screen</h5>
        <Table bordered className="text-center table-striped mx-auto mt-5">
          <thead className="table-primary">
            <tr >
              <th className="text-center" colSpan={2}>Section </th>
              <th className="text-center">Total Questions</th>
              <th className="text-center">Correct Answers</th>
              <th className="text-center">Action</th>
            </tr>
          
          </thead>
          <tbody>
          {!isLoading && subsets ? (
              subsets.map((subset, index) => (
                <tr key={index}>
                  <td className="fs-6 fw-bold" colSpan={2}>{subset.title}</td>
                  <td>
                    {subset.questions_count}
                  </td>
                  <td>
                    {subset.correct_answers}
                  </td>
                  <td>
                  <button onClick={() => onReviewClick(subset.id)} className="btn btn-base">Review</button> 
                  </td>
                </tr>
              ))
              ):(
                <tr >
                  <td colSpan={3} className="text-center text-dark my-3">
                    <span className="spinner spinner-border text-dark spinner-sm"></span> Loading...
                  </td>
                </tr>
              
              )
            }
          </tbody>
        </Table>
    
    </Container>
  );

};

export default SummaryScreen;
